module.exports = __webpack_public_path__ + "static/media/mentor_signpost.06b8a254.svg";